module.exports = __webpack_public_path__ + "static/img/stm.15443d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/stm.jpg
// module id = kU2s
// module chunks = 1